import React, { useEffect, useState } from 'react'
import { Filter as FilterProps, SelectedFilter } from '../../models/shop-product-category.model'
import ShopProductCategoryCurrentFilter from './ShopProductCategoryCurrentFilter'
import { revertFilterChange } from '../../utils'

interface ShopProductCategoryFilterProps {
  filters: FilterProps[]
  selectedFilters: SelectedFilter[]
  onFilterChange: (key: string, value: string[]) => void
}

interface FormattedFilterProps {
  key: string
  name: string
  filterOptions: SelectedFilter[]
}

/*
 * This component get all the filters and reformat them to Filter Form.
 */
const ShopProductCategoryFilter: React.VFC<ShopProductCategoryFilterProps> = ({ filters, selectedFilters, onFilterChange }) => {
  const [formattedFilters, setFormattedFilters] = useState<FormattedFilterProps[]>([])

  useEffect(() => {
    /** TODO: Pull out a function for filteredBuckets outside of useEffect */
    const filtersFormatted: FormattedFilterProps[] = []
    Object.entries(filters).forEach(([key, aggregation]) => {
      if (aggregation.buckets) {
        let filterOptions: SelectedFilter[] = []
        const filteredBuckets = aggregation.buckets.filter(bucket => bucket.key !== '')
        const name = aggregation.extensions?.translation?.name ?? ''
        filterOptions = filteredBuckets.map(bucket => ({
          value: bucket.key,
          label: bucket.extensions?.translation.name || bucket.key,
        }))
        filtersFormatted.push({ key, filterOptions, name })
      }

      if (aggregation.entities) {
        aggregation.entities.forEach((properties, index) => {
          let filterOptions: SelectedFilter[] = []
          const name = properties.translated.name
          const propertiesKey = key + index
          if (properties.options) {
            filterOptions = properties.options.map(option => ({
              value: option.id,
              label: option.translated.name,
            }))
          }
          filtersFormatted.push({ key: propertiesKey, filterOptions, name })
        })
      }
    })

    const availableFilters = filtersFormatted.filter(filter => filter.filterOptions.length > 0)
    setFormattedFilters(availableFilters)
  }, [filters])

  return (
    <>
      {formattedFilters.map(filters => {
        const selectedValues = revertFilterChange(filters.key, selectedFilters)

        return (
          <ShopProductCategoryCurrentFilter
            key={filters.key}
            selectedValues={selectedValues}
            options={filters.filterOptions}
            filterKey={filters.key}
            filterName={filters.name}
            onFilterChange={onFilterChange}
          />
        )
      })}
    </>
  )
}

export default ShopProductCategoryFilter
